import React, { useState } from "react";
import Axios from "axios";
import { useTranslation } from "react-i18next";
import { baseURL, TESTIMONIAL } from "../../../Api/Api";
import { Button } from "react-bootstrap";
import { Alert, Rating } from "@mui/material"; // Import MUI Rating
import Form from "react-bootstrap/Form";

function RateUsSection() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    comment: "",
    rating: "", // Default rating
    status: "pending",
  });
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle rating change
  const handleRatingChange = (event, newValue) => {
    setFormData({ ...formData, rating: newValue });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setAlert(null);

    try {
      const response = await Axios.post(`${baseURL}/${TESTIMONIAL}`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        setAlert({ type: "success", message: t("rateUsSuccessMessage") });
        setFormData({ name: "", comment: "", rating: "" });
      } else {
        setAlert({ type: "error", message: t("errorMessage") });
      }
    } catch (error) {
      setAlert({ type: "error", message: t("errorMessage") });
    }

    setAlertVisible(true);
    setTimeout(() => setAlertVisible(false), 4000);
    setLoading(false);
  };

  return (
    <section id="contact" className="contact section">
      <div className="container">
        {alert && alertVisible && (
          <Alert
            dir="ltr"
            severity={alert.type}
            onClose={() => setAlertVisible(false)}
            sx={{
              transition: "opacity 1s ease-out",
              opacity: alertVisible ? 1 : 0,
              marginBottom: "10px",
            }}
          >
            {alert.message}
          </Alert>
        )}

        <Form onSubmit={handleSubmit} className="php-email-form">
          <div className="row gy-4">
            <div className="col-md-12">
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder={t("nameLabel")}
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-12">
              <textarea
                type="text"
                name="comment"
                className="form-control"
                rows={7}
                placeholder={t("messageLabel")}
                value={formData.comment}
                onChange={handleChange}
                required
              />
            </div>

            {/* MUI Star Rating */}
            <div className="col-md-12">
              <label>{t("ratingLabel")}</label>
              <br />
              <div dir="ltr">
                <Rating
                  name="rating"
                  value={formData.rating}
                  onChange={handleRatingChange}
                  precision={1}
                  size="medium"
                  sx={{
                    "& .MuiRating-iconEmpty": { color: "#ccc" }, // Gray color for empty stars
                    "& .MuiRating-iconFilled": { color: "#f39c12" }, // Gold color when selected
                    "& .MuiRating-iconHover": { color: "#e67e22" }, // Slightly darker gold on hover
                  }}
                />
              </div>
            </div>

            <div className="col-md-12 text-center">
              <Button type="submit" disabled={loading}>
                {loading ? t("sending") : t("submit")}
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </section>
  );
}

export default RateUsSection;
